import axios from "axios";
import baseUrl from "../Api";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { Navigate } from "react-router-dom";

function authHeader() {
  return {
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Content-Type": "application/json",
  };
}

// ─── Attendance Marking (Present / Absent / On Duty) ──────────────────────

export async function markAttendance(type) {
  try {
    return await axios
      .post(`${baseUrl}/markattendance`, { type }, { headers: authHeader() })
      .then((response) => response.data)
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function adminMarkAttendance(data) {
  try {
    return await axios
      .post(`${baseUrl}/adminmarkattendance`, data, { headers: authHeader() })
      .then((response) => response.data)
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function clockIn() {
  try {
    return await axios
      .post(`${baseUrl}/clockin`, "", { headers: authHeader() })
      .then((response) => response.data)
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function clockOut() {
  try {
    return await axios
      .post(`${baseUrl}/clockout`, "", { headers: authHeader() })
      .then((response) => response.data)
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function getAttendanceStatus() {
  try {
    return await axios
      .get(`${baseUrl}/attendancestatus`, { headers: authHeader() })
      .then((response) => response.data)
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function attendancelist(params) {
  try {
    return await axios
      .get(`${baseUrl}/attendancelist`, { headers: authHeader(), params })
      .then((response) => response.data)
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function attendancestafflist(params) {
  try {
    return await axios
      .get(`${baseUrl}/attendancestafflist`, { headers: authHeader(), params })
      .then((response) => response.data)
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// ─── Leave Management ─────────────────────────────────────────────────────

export async function applyLeave(data) {
  try {
    return await axios
      .post(`${baseUrl}/applyleave`, data, { headers: authHeader() })
      .then((response) => response.data)
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function approveLeave(data) {
  try {
    return await axios
      .post(`${baseUrl}/approveleave`, data, { headers: authHeader() })
      .then((response) => response.data)
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function getLeaveRequests(params) {
  try {
    return await axios
      .get(`${baseUrl}/leavelist`, { headers: authHeader(), params })
      .then((response) => response.data)
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function getMyLeaves(params) {
  try {
    return await axios
      .get(`${baseUrl}/myleaves`, { headers: authHeader(), params })
      .then((response) => response.data)
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function deleteLeave(data) {
  try {
    return await axios
      .post(`${baseUrl}/deleteleave`, data, { headers: authHeader() })
      .then((response) => response.data)
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

// ─── Late Clock-in (backward compat) ──────────────────────────────────────

export async function lateclockinrequests(params) {
  try {
    return await axios
      .get(`${baseUrl}/lateclockinrequests`, { headers: authHeader(), params })
      .then((response) => response.data)
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

export async function lateclockinaction(data) {
  try {
    return await axios
      .post(`${baseUrl}/lateclockinaction`, data, { headers: authHeader() })
      .then((response) => response.data)
      .catch((error) => {
        catcherror(error);
      });
  } catch (error) {
    catcherror(error);
  }
}

function catcherror(error) {
  console.log(error);
  if (error.response.status === 401) {
    localStorage.clear();
    window.location.reload();
    <Navigate to={"/login"} />;
  } else if (error.response.status === 422) {
    Swal.fire({
      title:
        "There are few errors occured while inserting/updating the data to the database.",
      showCancelButton: false,
      confirmButtonColor: "#d71635",
      confirmButtonText: "Ok",
      allowOutsideClick: false,
    });
  } else if (error.response.status === 0) {
    toast.error(error.message);
  } else if (error.response.status === 500) {
    toast.error(error.response.statusText);
  } else if (
    error.response.status !== 200 &&
    error.response.data.status === false &&
    error.response.data.code !== 200
  ) {
    toast.error(error.response.data.message);
  } else if (error.request) {
    toast.error(error.request.statusText);
  } else {
    toast.error(error.message);
  }
}
